import { Component } from '@angular/core';
import {ButtonModule} from "@progress/kendo-angular-buttons";
import {FormFieldModule, TextBoxModule} from "@progress/kendo-angular-inputs";
import {LabelModule} from "@progress/kendo-angular-label";
import {ReactiveFormsModule} from "@angular/forms";

@Component({
  selector: 'af-not-found-page',
  imports: [
    ButtonModule,
    FormFieldModule,
    LabelModule,
    ReactiveFormsModule,
    TextBoxModule
  ],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss'
})
export class NotFoundPageComponent {

}
